export default __webpack_public_path__ + "static/media/lifecycle_components.5b02f68d.PNG";